export const HEADER_HIDE_SCROLLING_PATH_PREFIXES = ['/danh-gia', '/buoc6', '/buoc5'] as const;

/** Bước 5: ẩn header khi cuộn xuống, hiện lại khi cuộn lên (khi bật bsc_header_scroll_hide) */
export const HEADER_SCROLL_UP_SHOW_PATH_PREFIXES = ['/buoc5'] as const;

export function isHeaderHideScrollingPath(pathname: string | undefined | null): boolean {
  if (!pathname) return false;
  return HEADER_HIDE_SCROLLING_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function isHeaderScrollUpShowPath(pathname: string | undefined | null): boolean {
  if (!pathname) return false;
  return HEADER_SCROLL_UP_SHOW_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

